import { Delete, OpenInNew } from "@mui/icons-material";
import { Box, Card, CardActionArea, CardContent, Checkbox, Chip, IconButton, Tooltip, tooltipClasses, Typography } from "@mui/material";
import { Fragment } from "react";
import { styled } from '@mui/material/styles';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))

function stripHtml(html = "") {
    const tmp = document.createElement("div")
    tmp.innerHTML = html;
    return tmp.textContent || ""
}

function formatDate(str) {
    if (!str) return "";
    return new Date(str).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    })
}

const CalledCard = ({ item, onClick, onDelete, match, selectable = false, selected = false }) => {
    const desc = stripHtml(item.description)

    const handleOpenInNewTab = (id) => {
        const url = `/${match.params.lang}/called-accompaniment/${id}`
        window.open(url, "_blank")
    }
    return (
        <Card
            variant="outlined"
            sx={{
                position: "relative",
                borderColor: "divider",
                borderWidth: 1,
                bgcolor: "background.paper",
                height: "100%",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    top: 6,
                    right: 6,
                    display: "flex",
                    gap: 0.5,
                    zIndex: 2,
                }}
            >
                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation()
                        handleOpenInNewTab(item.id)
                    }}
                >
                    <OpenInNew fontSize="small" />
                </IconButton>
            </Box>

            <CardActionArea
                onClick={() => onClick(item.id)}
                sx={{ height: "100%", alignItems: "flex-start" }}
            >
                <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1, height: "100%" }}>
                    {/* Top: checkbox + título */}
                    <Box display="flex" alignItems="flex-start" gap={1}>
                        {selectable && <Checkbox
                            checked={selected}
                            size="small"
                            disableRipple
                            tabIndex={-1}
                            sx={{ p: 0, mt: "2px", flexShrink: 0, pointerEvents: "none" }}
                        />}
                        <Typography variant="subtitle2" fontWeight={600} lineHeight={1.4}>
                            {item.id}
                        </Typography>
                    </Box>
                    <Typography variant="subtitle2" fontWeight={600} lineHeight={1.4}>
                        {item.title}
                    </Typography>

                    {/* Meta: solicitante + data */}
                    <Typography variant="caption" color="text.disabled">
                        por {item.requestinguser} · {formatDate(item.openingdate)}
                    </Typography>
                </CardContent>
                {
                    !selectable &&
                    (
                        <Box
                            sx={{
                                position: "absolute",
                                bottom: 6,
                                right: 6,
                                display: "flex",
                                gap: 0.5,
                                zIndex: 2,
                            }}
                        >
                            <IconButton
                                size="small"
                                color="error"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onDelete(item)
                                }}
                            >
                                <Delete fontSize="small" />
                            </IconButton>
                        </Box>
                    )
                }
            </CardActionArea>
        </Card>
    )
}

export default CalledCard